import {requestWrapper} from "@/js/requestWrapper";

const baseUrl = process.env.VUE_APP_API_URL;

const defaultHeaders = {
  'Accept': 'application/json',
  'Content-Type': 'application/json;charset=UTF-8'
};

export async function listTherapists(stateName = null, cityName = null) {
  return await requestWrapper(async () => {
    const url = new URL(`${baseUrl}/api/therapists`);

    if (stateName) {
      url.searchParams.append('stateName', stateName);
    }
    if (cityName) {
      url.searchParams.append('cityName', cityName);
    }

    return await fetch(url, {
      credentials: 'include',
    })
  })
}

export async function getTherapist(id) {
  if (!id) {
    return
  }
  
  return await requestWrapper(async () => await fetch(`${baseUrl}/api/therapists/${id}`, {
    credentials: 'include',
  }))
}

export async function updateTherapist(therapist) {
  if (!(therapist && therapist.id)) {
    return
  }
  
  return await requestWrapper(async () => await fetch(`${baseUrl}/api/therapists/${therapist.id}`, {
    headers: defaultHeaders,
    method: 'PUT',
    credentials: 'include',
    body: JSON.stringify(therapist),
  }))
}

export async function deleteTherapist(id) {
  if (!id) {
    return
  }
  return await requestWrapper(async () => await fetch(`${baseUrl}/api/therapists/${id}`, {
    headers: defaultHeaders,
    credentials: 'same-origin',
    method: "DELETE",
  }))
}
